import { useEffect, useState } from 'react';
import { categories } from '@/mocks/gossip';

const navLinks = [
  { id: 'timeline', label: '今日汇总' },
  { id: 'feed', label: '热门瓜料' },
  { id: 'featured', label: '深度专题' },
  { id: 'principles', label: '吃瓜守则' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const sections = navLinks.map((l) => document.getElementById(l.id)).filter(Boolean) as HTMLElement[];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/90 shadow-card backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-2"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 text-lg text-background-50 shadow-card">
            <i className="ri-focus-3-line" />
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-600">大全</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => handleAnchor(e, l.id)}
              className={`whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                active === l.id
                  ? 'bg-accent-100 text-accent-800'
                  : 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <div className="hidden items-center gap-1.5 xl:flex">
            {categories.slice(1, 4).map((c) => (
              <a
                key={c.key}
                href="#feed"
                onClick={(e) => handleAnchor(e, 'feed')}
                className="rounded-full bg-background-200/80 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {c.label}
              </a>
            ))}
          </div>
          <a
            href="#feed"
            onClick={(e) => handleAnchor(e, 'feed')}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始吃瓜
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 lg:hidden"
        >
          <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 shadow-card lg:hidden">
          <nav className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={(e) => handleAnchor(e, l.id)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-800"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#feed"
              onClick={(e) => handleAnchor(e, 'feed')}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              开始吃瓜
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}